import { Dispatcher } from "@fanfanlo";
import { projectEventUtils } from "../events/projectEventUtils";

export class ProjectInterfaceController extends Dispatcher{
    constructor(){
        super();
    }
    async init(){
        projectEventUtils.init();
    }
}

export const projectInterfaceController = new ProjectInterfaceController();